module.exports = __webpack_public_path__ + "img/plan7.b4c05365.png";